module.exports = __webpack_public_path__ + "static/dyrket_screen-4e758f8a7141c78247dde82e16269780.jpg";